import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Navbar() {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: '#manufacturing', label: t.nav.manufacturing },
    { href: '#inspection', label: t.nav.inspection },
    { href: '#field-services', label: t.nav.fieldServices },
    { href: '#reach', label: t.nav.reach },
    { href: '#gallery', label: t.nav.gallery },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled ? 'bg-[#1A1A2E]/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-[#1A1A2E]/70 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" data-testid="nav-logo" className="flex-shrink-0">
          <img
            src="https://customer-assets.emergentagent.com/job_wind-services-hub/artifacts/gy20fiwt_Yira-Wind-Services-logo-rojo-blanco.svg"
            alt="Yira Wind Services"
            className="h-10"
          />
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
              className="text-sm font-medium text-[#B0B0B0] hover:text-white transition-colors duration-300 tracking-wide uppercase"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Language toggle + mobile menu */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2" data-testid="language-toggle">
            <button
              onClick={() => setLang('en')}
              data-testid="lang-en"
              className={`text-xl leading-none px-1 py-0.5 rounded transition-all duration-300 ${
                lang === 'en' ? 'ring-2 ring-[#E71C25] scale-110' : 'opacity-50 hover:opacity-80'
              }`}
              title="English"
            >
              🇺🇸
            </button>
            <button
              onClick={() => setLang('es')}
              data-testid="lang-es"
              className={`text-xl leading-none px-1 py-0.5 rounded transition-all duration-300 ${
                lang === 'es' ? 'ring-2 ring-[#E71C25] scale-110' : 'opacity-50 hover:opacity-80'
              }`}
              title="Espa\u00F1ol"
            >
              🇲🇽
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden flex flex-col gap-1.5 p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-5 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#1A1A2E]/98 backdrop-blur-lg border-t border-white/5 px-6 py-4 space-y-3">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block text-sm font-medium text-[#B0B0B0] hover:text-white transition-colors uppercase tracking-wide py-2"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
